import SOURCES_TABLE_CONFIG from '../../models/sourcesTableConfig.js';

class SourceTableController {
  constructor() {
    this.name = 'sourceTable';
    this.tab = angular.copy(SOURCES_TABLE_CONFIG);
    this.options = this.tab.options;
    this.options.uri = `${this.options.uri}/${this.row.id}/sourceFiles`;
  }
}

export default SourceTableController;



// WEBPACK FOOTER //
// ./app/components/sourceTable/sourceTable.controller.js